import { render, staticRenderFns } from "./addControl.vue?vue&type=template&id=7048a00c&scoped=true"
import script from "./addControl.vue?vue&type=script&lang=js"
export * from "./addControl.vue?vue&type=script&lang=js"
import style0 from "./addControl.vue?vue&type=style&index=0&id=7048a00c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7048a00c",
  null
  
)

export default component.exports